import request from ".";

// 获取省市区
function getCity(data = null){
  let url = '/info/area/getCity'
  if(data !== null ){
    url = url + '?province=' + data.id
  }
  return request(url, 'get')
}

// 获取省份
function getProvince(){
  return request('/info/area/getProvince', 'get')
}

// 获取汇率
function getRate(){
  return request('/info/getExchangeRate', 'post')
}

// 获取亚马逊费用
function getAmazonLogisticsFee(data){
  return request('/info/getAmazonLogisticsFee', 'post', data)
}

// 获取增值税
function getImportVat(data){
  return request('/info/getImportVat', 'post', data)
}

// 导入试用数据埋点
function importTrialDataTrackingPoints(){
  return request('/support-server/log/visit/homeCalculateImport', 'post')
}

// 利润计算埋点
function profitCalculationTriggerPoint(){
  return request('/support-server/log/visit/homeCalculate', 'post')
}

// 注册埋点
function registerTrackingPoints(){
  return request('/support-server/log/visit/toRegisterPage', 'post')
}

// 首页修改利润数据埋点
function modifyDataCollectionPoints(){
  return request('/support-server/log/visit/updateProductFrontPage', 'post')
}

// 保存首页数据埋点
function saveDataTrackingPoints(){
  return request('/support-server/log/visit/updateProductFront', 'post')
}

// 汇总分摊埋点
function summarizeAndAllocateDataCollectionPoints(){
  return request('/support-server/log/visit/salesCollect','post')
}

/**上传图片 */
function uploadImg(data){
  let formFile = new FormData()
  formFile.append('file', data)
  formFile.append('fileType', 'FT0016')
  return request('/support-server/v1/fileInfo/uploadFile', 'post', formFile, 'application/x-www-form-urlencoded')
}

/**上传文件 */
function uploadFile(data, fileType){
  let formFile = new FormData()
  formFile.append('file', data)
  formFile.append('fileType', fileType != null ? fileType : 'FT0002')
  return request('/support-server/v1/fileInfo/uploadFile', 'post', formFile, 'application/x-www-form-urlencoded')
}

/**查看文件 */
function watchFile(data){
  return request('/support-server/v1/fileInfo/downloadFile/' + data, 'post', {}, 'application/json', { responseType: 'arraybuffer' })
}

export default{
  getCity,
  getRate,
  getProvince,
  getAmazonLogisticsFee,
  getImportVat,
  importTrialDataTrackingPoints,
  profitCalculationTriggerPoint,
  registerTrackingPoints,
  modifyDataCollectionPoints,
  saveDataTrackingPoints,
  summarizeAndAllocateDataCollectionPoints,
  uploadImg,
  uploadFile,
  watchFile
}
